import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SEO from "../../common/context/SeoContext";
import Footer from "../../common/components/Footer/Footer";
import HomeProducts from "./sections/HomeProducts";
import HomeWhy from "./sections/HomeWhy";
import HomeTestimonials from "./sections/HomeTestimonials";
import HomeMadeInIndia from "./sections/HomeMadeInIndia";
import HomeAppBand from "./sections/HomeAppBand";
import HomeBlog from "./sections/HomeBlog";
import { useLoginMode } from "../../hooks/useLoginMode";
import { useCustomerCredits } from "../../hooks/useCustomerCredits";
import { useHomeAnalytics } from "../../hooks/useHomeAnalytics";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import LegacyHome from "./LegacyHome";
import { AnnouncementBar } from "./components";
import ProductSearchHero from "./components/ProductSearchHero";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./HomePage.theme.css";
import "./HomeMist.css";

const PHONE = "(max-width: 767px)";

// Desktop home: layout and "Mist Blue" palette follow the Home view of the
// JaaGa Website MVP artifact (claude.ai/artifact/B59fKADQNTPdAdcgPK8JtP).
// The top of the page (hero + state documents) is still the production one,
// ProductSearchHero, in its own .jaaga-home scope so the two themes don't mix;
// .home-light recolours it from navy to Mist blue (HomeMist.css).
const MistHome = () => {
  useScrollReveal(".jaaga-home");
  return (
    <main id="main-content">
      <div className="jaaga-home home-light">
        <AnnouncementBar />
        <ProductSearchHero />
      </div>
      <div className="mist-home">
        <HomeProducts />
        <HomeWhy />
        <HomeTestimonials />
        <HomeMadeInIndia />
        <HomeAppBand />
        <HomeBlog />
      </div>
    </main>
  );
};

// Phones keep the previous home page; the new design is desktop only.
const HomePage = () => {
  const { Info: customerInfo } = useSelector((state) => state.customer);
  const userType = useLoginMode();
  const phone = useMediaQuery(PHONE);
  // Hydrating the prerendered (desktop) HTML: render desktop first so the
  // markup matches, then switch phones over once mounted.
  const [hydrated, setHydrated] = useState(() => !window.__JAAGA_PRERENDERED__);
  useEffect(() => setHydrated(true), []);
  const isPhone = hydrated && phone;

  useCustomerCredits(customerInfo, userType);
  useHomeAnalytics(customerInfo, userType);

  return (
    <>
      <SEO
        title="JaaGa: Property Audit Report | Know if a property is safe to buy"
        pageLink="https://www.jaaga.ai"
        description="JaaGa collects every legal document of a property, audits them for hidden risks, and gives you one clear verdict: is it safe to buy? Title, encumbrance, litigation, RERA, property tax and 40+ government records, verified. Made in India."
        name="JaaGa: Property Audit Report, Documents & Services"
        type="JaaGa - Property Audit Report"
        keywords="property audit report, is this property safe to buy, title verification, encumbrance certificate, EC, RERA check, property documents, land records, mutation, property tax, legal opinion, property verification India, made in india proptech"
      />

      {isPhone ? <LegacyHome /> : <MistHome />}

      <Footer />
    </>
  );
};

export default HomePage;
